import moment from "moment";

import VisitorCharacteristicsActioner from "./actioner";
import VisitorCharacteristicsActionTypes from "./types";

const VisitorCharacteristicsMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState);
    }
    if (
      action.type ===
      VisitorCharacteristicsActionTypes.SET_QUALIFICATION_INDICATORS_FILTERS
    ) {
      next(action);

      dispatch(
        VisitorCharacteristicsActioner.retrieveQualificationIndicatorsByDayOfWeek()
      );
      return;
    }
    if (
      action.type ===
      VisitorCharacteristicsActionTypes.SET_QUALIFICATION_VISITORS_FILTERS
    ) {
      next(action);

      dispatch(
        VisitorCharacteristicsActioner.retrieveQualificationVisitorsByDayOfWeek()
      );
      return;
    }
    if (
      action.type ===
      VisitorCharacteristicsActionTypes.SET_QUALIFICATION_TIME_FILTERS
    ) {
      next(action);

      dispatch(
        VisitorCharacteristicsActioner.retrieveQualificationTimeByDayOfWeek()
      );
      return;
    }
    if (
      action.type ===
      VisitorCharacteristicsActionTypes.SET_QUALIFICATION_DESTINATION_FILTERS
    ) {
      next(action);

      dispatch(
        VisitorCharacteristicsActioner.retrieveQualificationDestinationByDayOfWeek()
      );
      return;
    }
    if (
      action.type ===
      VisitorCharacteristicsActionTypes.SET_QUALIFICATION_CATCHMENT_AREAS_FILTERS
    ) {
      next(action);
      dispatch(VisitorCharacteristicsActioner.retrieveCatchmentAreas());
      return;
    }
    if (
      action.type === VisitorCharacteristicsActionTypes.SET_FILTER &&
      action.key === "nbDaysFromDate"
    ) {
      next(action);

      const from = parseInt(
        moment()
          .subtract(1, "days")
          .subtract(action?.value, "days")
          .startOf("day")
          .unix()
      );
      const to = parseInt(moment().subtract(1, "days").endOf("day").unix());

      dispatch(VisitorCharacteristicsActioner.setFilter("from", from));
      dispatch(VisitorCharacteristicsActioner.setFilter("to", to));

      return;
    }

    return next(action);
  };

export default VisitorCharacteristicsMiddleware;
